import FormattedWater from './FormattedWater';

export default FormattedWater;
